import { useEffect } from 'react'
import { AllSurrogateTransactionsSummariesHook } from '../hooks/SurrogateTransactionsHooks'
import { AdminDashboardTableSummary } from './AdminDashboardTableSummary'
import { fetchAllSurrogateTransactions } from '../../store/slices/surrogateUserTransactionsSlice'
import { useDispatch } from 'react-redux';


/**
 * Component that renders the admins dashboard for the Vinco advisors
 * @returns {JSX.Element} - The corresponding component
 */
function AdminDashboard() {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAllSurrogateTransactions())
  }, [dispatch])
  
  // Hook for the surrogate transaction summaries
  const [allSurrogateTransactionsSummaries, computing] = AllSurrogateTransactionsSummariesHook()
 
  return (
    <div>
      <AdminDashboardTableSummary allSurrogateTransactionsSummaries={allSurrogateTransactionsSummaries}
                                  computing={computing}/>
    </div>
  )
}

export default AdminDashboard